<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      ref="quizList"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
    <b-modal v-model="isActiveModal"
             :no-close-on-backdrop="true"
             centered title="Confirmation"
             @cancel="closeActiveModal"
             @ok="activeQuiz">
      <form>
        <h3 class="text-black-50">{{ message }}</h3>
      </form>
    </b-modal>
    <b-modal v-model="isClearModal"
             :no-close-on-backdrop="true"
             centered title="Confirmation"
             @cancel="closeClearModal"
             @ok="clearQuiz">
      <form>
        <h3 class="text-black-50">Do you really want to clear the DB</h3>
      </form>
    </b-modal>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import moment from 'moment'
let id = null

export default {
  name: 'QuizListPage',
  data () {
    return {
      active: true,
      isActiveModal: false,
      isClearModal: false,
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            let activeItem
            let clearItem
            if (item.active) {
              activeItem = <b-dropdown-item onClick={() => this.showActiveModal(item.id, false)}>Deactivate</b-dropdown-item>
            } else {
              activeItem = <b-dropdown-item onClick={() => this.showActiveModal(item.id, true)}>Activate</b-dropdown-item>
              clearItem = <b-dropdown-item onClick={() => this.showClearModal(item.id)}>Clear Tries</b-dropdown-item>
            }
            return (
              <b-dropdown variant="link" class="listing-action">
                <b-dropdown-item href={'#/quiz/edit/' + item.id}>Edit</b-dropdown-item>
                {activeItem}
                <b-dropdown-item href={'#/question/add-by-quiz/' + item.id}>Add Question</b-dropdown-item>
                <b-dropdown-item href={'#/quiz/user-tries/' + item.id}>User Tries</b-dropdown-item>
                <b-dropdown-item href={'#/quiz/winners/' + item.id}>Winners</b-dropdown-item>
                {clearItem}
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'title',
          columnName: 'Title',
          align: 'left',
          value: item => {
            return item.title
          }
        },
        {
          columnCode: 'active',
          columnName: 'Status',
          align: 'left',
          value: item => {
            return item.active ? 'Active' : 'Inactive'
          }
        },
        {
          columnCode: 'points',
          columnName: 'Points',
          align: 'left',
          value: item => {
            return item.points
          }
        },
        {
          columnCode: 'seconds',
          columnName: 'Each Question Seconds',
          align: 'left',
          value: item => {
            return item.seconds
          }
        },
        {
          columnCode: 'totalMinutes',
          columnName: 'Total Quiz Time',
          align: 'left',
          value: item => {
            return item.totalMinutes
          }
        },
        {
          columnCode: 'maxQuestionCount',
          columnName: 'Limit Questions',
          align: 'left',
          value: item => {
            return item.maxQuestionCount
          }
        },
        {
          columnCode: 'endDate',
          columnName: 'End Date',
          align: 'left',
          value: item => {
            return item.endDate ? moment(item.endDate).format('YYYY-MM-DD HH:mm') : ''
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('quiz/list', payload)
    },
    addNewButton () {
      return (<router-link class="btn btn-success mr-3" to="/quiz/add"><div class="icon-plus"></div></router-link>)
    },
    showActiveModal (itemId, isActive) {
      if (!itemId) {
        this.$toastr.error('Item not found')
      }
      id = itemId
      this.active = isActive
      this.isActiveModal = true
    },
    closeActiveModal () {
      id = null
      this.active = true
      this.isActiveModal = false
    },
    showClearModal (itemId) {
      if (!itemId) {
        this.$toastr.error('Item not found')
      }
      id = itemId
      this.isClearModal = true
    },
    closeClearModal () {
      id = null
      this.isClearModal = false
    },
    activeQuiz () {
      if (!id) {
        return
      }
      this.$loading.show()
      this.axios.put('quiz/active', {id: id, active: this.active})
        .then((result) => {
          this.$refs.quizList.doRequest()
          this.$loading.hide()
          if (result && result.data && result.data.status === 200) {
            this.$toastr.success('Quiz successfully activated')
          }
          this.isActiveModal = false
          id = null
        })
    },
    clearQuiz () {
      if (!id) {
        return
      }
      this.$loading.show()
      this.axios.delete('quiz/clear', {params: {id: id}})
        .then((result) => {
          this.$refs.quizList.doRequest()
          this.$loading.hide()
          if (result && result.data && result.data.status === 200) {
            this.$toastr.success(result.data.message)
          }
          this.isClearModal = false
          id = null
        })
        .catch(error => {
          this.$loading.hide()
          if (error.response && error.response.data.status === 400) {
            this.$toastr.error(error.response.data.message)
          }
          this.isClearModal = false
          id = null
        })
    }
  },
  computed: {
    message () {
      return this.active ? 'Do you really want to activate' : 'Do you really want to deactivate'
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/quiz/QuizListPage.vue